var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLinkexternal = function SvgLinkexternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 1.834h2.438a.933.933 0 110 1.867H3.2v9.6h9.6v-1.772a.933.933 0 011.867 0v2.305c0 .736-.597 1.333-1.334 1.333H2.667a1.333 1.333 0 01-1.334-1.333V3.167c0-.736.597-1.333 1.334-1.333z",
    fill: "#020814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.042 8.849a.94.94 0 01-1.254-.885V5.06L9.15 8.698A.842.842 0 117.96 7.507l3.75-3.75H8.685a.93.93 0 010-1.86h3.852a2.131 2.131 0 012.13 2.131v3.936a.94.94 0 01-.624.885z",
    fill: "#020814"
  })));
};
export default SvgLinkexternal;